import { MetaModelViewGraphNode } from '@ardoq/graph';
import { anyType } from '@ardoq/global-consts';
import { MetadataComponent } from './types';
import { getRepresentationDataWithColorVariants } from './components/getRepresentationDataWithColorVariants';
import { getComponentTypeDisplayLabel } from './traversals/getComponentTypeDisplayLabel';

const nodeToMetaDataComponent = (
  node: MetaModelViewGraphNode | undefined,
  isHierarchyWildcardActive: boolean
): MetadataComponent | null => {
  if (!node?.metaData?.representationData) {
    return null;
  }
  return {
    typeId: node.getTypeId(),
    color: node.getColor() ?? '',
    label:
      node.modelId === anyType
        ? getComponentTypeDisplayLabel(node.modelId, isHierarchyWildcardActive)
        : node.getLabel(),
    representationData: getRepresentationDataWithColorVariants(
      node.metaData.representationData
    ),
  };
};

export const getNodeMetaDataFromGraphNodeId = (
  graphNodes: Map<string, MetaModelViewGraphNode>,
  id: string | null,
  isHierarchyWildcardActive: boolean
): MetadataComponent | null => {
  const node = graphNodes.get(id ?? '');
  return nodeToMetaDataComponent(node, isHierarchyWildcardActive);
};

// A node's `modelId` is the component type name; `getLabel()` renames the
// `anyType` sentinel for display.
export const getNodeMetaDataFromTypeName = (
  graphNodes: Map<string, MetaModelViewGraphNode>,
  typeName: string,
  isHierarchyWildcardActive: boolean
): MetadataComponent | null => {
  const node = Array.from(graphNodes.values()).find(
    node => node.modelId === typeName
  );
  return nodeToMetaDataComponent(node, isHierarchyWildcardActive);
};
